import { useQuery } from "@tanstack/react-query";
import { useMatchingRequestRefetch } from "PFCore/hooks/use_matching_request_refetch";
import { fetchShortlistsRanked, RankedShortlistCollection } from "PFCore/services/shortlist";
import { Id, QueryOptions, QueryParams } from "PFTypes";

import { rankedShortlistsKeys } from "./query_keys";

type UseActivityRankedShortlists = {
  activityId: Id;
  profileIds?: Id[];
  params?: QueryParams;
  options?: QueryOptions<RankedShortlistCollection>;
};

export const useActivityRankedShortlists = ({
  activityId,
  profileIds = [],
  params = {},
  options = {}
}: UseActivityRankedShortlists) => {
  const getMatchingRefetchInterval = useMatchingRequestRefetch<RankedShortlistCollection, Error>();

  const queryKey = rankedShortlistsKeys.activityRankedShortlists(activityId, profileIds);

  const query = useQuery<RankedShortlistCollection>({
    queryKey,
    queryFn: () => fetchShortlistsRanked(activityId, profileIds, params.page, params.perPage),
    retry: false,
    staleTime: 0,
    refetchInterval: getMatchingRefetchInterval,
    refetchIntervalInBackground: true,
    ...options
  });

  return query;
};
